import { User } from '../shared/types';

export const getUsersWithNames = (users: User[] = []): User[] =>
    users.filter((user: User) => !!user.name);
export const getContributorRoleUsers = (users: User[]): User[] =>
    users.filter((user: User) => hasContributorScope(user.scopes));

const hasContributorScope = (scopes: string[]): boolean => {
    if (scopes.some((x) => x === 'insights:content-publish')) return true;
    if (scopes.some((x) => x === 'insights:content-edit')) return true;

    return false;
};
